import { Stack } from '@mui/material';

import { MultiDocumentUploaderWithListV2 } from '@/modules/documents/MultiDocumentUploader/MultiDocumentUploaderWithListV2';

interface ClientMultiDocumentUploaderProps {
  householdId: string;
  allowSelectExistingDocuments?: boolean;
}

export function ClientMultiDocumentUploader({
  householdId,
  allowSelectExistingDocuments,
}: ClientMultiDocumentUploaderProps) {
  return (
    <Stack gap={2} data-testid="client-multi-document-uploader">
      <MultiDocumentUploaderWithListV2
        householdId={householdId}
        allowSelectExistingDocuments={allowSelectExistingDocuments}
      />
    </Stack>
  );
}
